<bevvi-bot-chat-card
  [type]="type.SELECT"
  [title]="payload().question || ''"
  [description]="payload().description || ''"
  [options]="payload().options"
  [disabled]="disabled()"
  (optionChange)="onSelectChange($event)"
/>
